/* eslint-disable @next/next/no-page-custom-font */
import React, { ReactNode } from 'react';
import Head from 'next/head';
import styles from '@/components/overseaHome/layout/index.module.scss';
import FeatureInit from '@/components/overseaHome/featureInit';

interface LayoutProps {
  children: ReactNode;
  theme?: 'light' | 'dark';
}

/**
 * 服务端渲染的布局组件
 * 只负责渲染静态的 Header、Footer 和页面结构
 * 所有客户端逻辑在 SubApp.tsx 中处理
 */
function Layout({
  children,
  theme = 'dark',
}: LayoutProps) {
  return (
    <>
      <Head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=Google+Sans+Flex:wdth,wght@75..125,100..900&display=swap"
          rel="stylesheet"
        />
        {/* 预加载背景视频 - PC */}
        <link rel="preload" as="video" type="video/webm" href="https://roboneo-public.meitudata.com/public/roboneo-web-assets/main_bg_video.webm" crossOrigin="anonymous" />
        <link rel="preload" as="video" type="video/mp4" href="https://roboneo-public.meitudata.com/public/roboneo-web-assets/main_bg_video.mp4" crossOrigin="anonymous" />
        {/* 预加载背景视频 - Mobile */}
        <link rel="preload" as="video" type="video/webm" href="https://roboneo-public.meitudata.com/public/roboneo-web-assets/mobile_bg_video.webm" crossOrigin="anonymous" />
        <link rel="preload" as="video" type="video/mp4" href="https://roboneo-public.meitudata.com/public/roboneo-web-assets/mobile_bg_video.mp4" crossOrigin="anonymous" />

      </Head>
      {/* 主内容区 */}
      <main className={styles.layoutMain} style={{ fontFamily: "'Google Sans Flex', sans-serif" }}>
        {children}
      </main>
      {/*  这是roboneo context的初始化，功能：totast等 */}
      <FeatureInit />
    </>
  );
}

export default Layout;
